import { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import AvailableDates from "./AvailableDates";
import AvailableTimeSlots from "./AvailableTimeSlots";
import moment from "moment";

function AvailableDatesAndSlots({ preferredDate, vendorAvailableSlots, apptDateAndTime, setApptTimeDateAndTime, scheduledDate, scheduledTime }) {
  const [selectedDate, setSelectedDate] = useState(preferredDate);
  const [tenDates, setTenDates] = useState(null);
  const [availableSlots, setAvailableSlots] = useState(null);
  const slotsRef = useRef(null);

  useEffect(() => {
    fetchTenDays();
    fetchSlotsForSelectedDate(preferredDate);
  }, []);

  const fetchTenDays = () => {
    const uniqueDatesMap = new Map();
    vendorAvailableSlots.forEach((slot) => {
      if (!uniqueDatesMap.has(slot.availableDate)) {
        uniqueDatesMap.set(slot.availableDate, {
          date: moment(slot.availableDate, "YYYYMMDD").toDate(),
          isAvailable: slot.isDateAvailable,
        });
      }
    });
    setTenDates(Array.from(uniqueDatesMap.values()).sort((a, b) => a.date - b.date));
  };

  const fetchSlotsForSelectedDate = (dateToFetch) => {
    let slots = vendorAvailableSlots.filter((date) => date.availableDate === moment(dateToFetch).format("YYYYMMDD") && date.isDateAvailable);
    if (slots.length) {
      slots = slots.map((slotDetails) => {
        let slotDate = moment(slotDetails.availableDate).format("MMMM D, YYYY");
        let slot = slotDetails.slotOption;
        let slotOption = scheduledTime && scheduledDate && slot === scheduledTime && slotDate === scheduledDate ? `${slot} (Former time)` : slot;
        return { ...slotDetails, slot, slotOption, slotDate };
      });
      setAvailableSlots(slots);
    } else {
      setAvailableSlots([]);
    }
  };

  return (
    <>
      {tenDates && availableSlots && (
        <>
          <AvailableDates
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            datesWithSlots={tenDates}
            fetchSlotsForSelectedDate={fetchSlotsForSelectedDate}
            setApptTimeDateAndTime={setApptTimeDateAndTime}
            slotsRef={slotsRef}
          />
          <AvailableTimeSlots
            availableSlots={availableSlots}
            apptDateAndTime={apptDateAndTime}
            setApptTimeDateAndTime={setApptTimeDateAndTime}
            slotsRef={slotsRef}
            dropdownClassName={availableSlots.length > 4 ? "slots-dropdown-panel-list" : `slots-dropdown-panel-list${availableSlots.length}`}
          />
        </>
      )}
    </>
  );
}

AvailableDatesAndSlots.propTypes = {
  preferredDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  vendorAvailableSlots: PropTypes.array,
  apptDateAndTime: PropTypes.object,
  setApptTimeDateAndTime: PropTypes.func,
  scheduledDate: PropTypes.string,
  scheduledTime: PropTypes.string,
};

export default AvailableDatesAndSlots;
